<template lang='pug'>
div
  b-modal(:active="isModalOpened", has-modal-card)
    form(onsubmit="event.preventDefault()")
      .modal-card
        .modal-card-head
          p.modal-card-title Create new collection
        .modal-card-body
          b-field(
            label="Insert new collection name",
            :type="inputNewCollectionNameType",
            :message="inputNewCollectionMessage"
          )
            b-input(
              ref="new_collection_name_input",
              placeholder="New collection name",
              v-model="uiNewCollectionName"
            )
        .modal-card-foot
          b-button(
            type="is-primary",
            @click="uiCreateCollection",
            native-type="submit"
          ) Confirm
          b-button(type="is-danger", @click="closeModal") Cancel
</template>
<script>
import { mapMutations, mapState, mapActions } from "vuex";
export default {
  data: () => ({
    inputNewCollectionNameType: "",
    inputNewCollectionMessage: "",
  }),
  watch: {
    isModalOpened(v) {
      if (v === true) {
        this.$nextTick(() => {
          this.$refs.new_collection_name_input.focus();
        });
      }
    },
  },
  computed: {
    ...mapState("createCollection", {
      isModalOpened: (s) => s.isModalOpened,
      newCollectionName: (s) => s.newCollectionName,
    }),
    ...mapState("collection", {
      rawCollections: (s) => s.rawCollections,
    }),
    uiNewCollectionName: {
      get() {
        return this.newCollectionName;
      },
      set(value) {
        this.setNewCollectionName(value);
        if (value !== "") {
          this.setInputNewCollectionDanger(false);
        }
      },
    },
  },
  methods: {
    ...mapMutations("createCollection", ["closeModal", "setNewCollectionName"]),
    ...mapMutations("saveRecord", ["selectCollection"]),
    ...mapActions("createCollection", ["createCollection"]),
    ...mapActions("collection", ["fetchCollections"]),

    async uiCreateCollection() {
      if (this.uiNewCollectionName === "") {
        this.setInputNewCollectionDanger(true);
      } else {
        const resp = await this.createCollection();
        if (resp.status === "success") {
          this.closeModal();
          await this.fetchCollections();
          this.openSuccessSnackbar("New collection is added");
          //select collectionId of newly created
          const newCollectionId = this.rawCollections.filter(
            (x) => x.name === this.newCollectionName
          )[0].id;
          this.selectCollection(newCollectionId);
        } else {
          this.openErrorSnackbar(
            resp.message ? resp.message : "Error! Please try again later"
          );
        }
      }
    },

    setInputNewCollectionDanger(value) {
      if (value) {
        this.inputNewCollectionNameType = "is-danger";
        this.inputNewCollectionMessage = "Collection name is empty!";
      } else {
        this.inputNewCollectionNameType = "";
        this.inputNewCollectionMessage = "";
      }
    },
  },
};
</script>